import { Box, Container, Typography, Card, Grid, useTheme } from "@mui/material";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import Page from "../Page";
import React from "react";

export default function ContactUs() {
  const theme = useTheme();
  
  return (
    <Page title="Contact Us | ChargeMiles" sx={{ marginTop: { xs: "128px", md: "62px" }, overflow: "hidden", minHeight: '100vh', pb: 10 }}>
      <Container maxWidth="lg" sx={{ py: { xs: 3, md: 5 } }}>
        <Card sx={{ 
          boxShadow: (theme) => `0 0 4px 0 rgba(145,158,171,0.24), 0 24px 48px 0 rgba(145,158,171,0.24)`,
          borderRadius: 3,
          overflow: "hidden" 
        }}>
          {/* Header Gradient */}
          <Box
            sx={{
              background: `linear-gradient(135deg, var(--app-color) 0%, ${theme.palette.primary.dark} 100%)`,
              color: '#fff',
              p: { xs: 4, md: 6 },
              textAlign: 'center',
            }}
          >
            <Typography variant="h3" fontWeight={700} gutterBottom>
              Contact Us
            </Typography>
            <Typography variant="body1" sx={{ opacity: 0.85, maxWidth: 600, mx: 'auto' }}>
              We're here to help. Reach out to us via phone, email, or visit our office.
            </Typography>
          </Box>

          <Box sx={{ p: { xs: 3, md: 8 } }}>
            <Grid container spacing={4} justifyContent="center">
              
              {/* Phone */}
              <Grid item xs={12} md={4}>
                <Box sx={{ textAlign: 'center', p: 4, borderRadius: 2, bgcolor: 'rgba(145,158,171,0.08)', height: '100%', transition: 'all 0.3s ease', '&:hover': { transform: 'translateY(-5px)', boxShadow: 3 } }}>
                  <Box sx={{ 
                    width: 80, height: 80, margin: '0 auto', mb: 3, 
                    display: 'flex', alignItems: 'center', justifyContent: 'center', 
                    borderRadius: '50%', background: `linear-gradient(135deg, var(--app-color) 0%, ${theme.palette.primary.dark} 100%)`, color: '#fff',
                    boxShadow: `0 8px 16px 0 rgba(25, 118, 210, 0.24)`
                  }}>
                    <LocalPhoneIcon sx={{ fontSize: 40 }} />
                  </Box>
                  <Typography variant="h5" fontWeight={600} gutterBottom color="text.primary">
                    Call Us
                  </Typography>
                  <Typography variant="body1" color="text.secondary" component="a" href="tel:+1-6477224348" sx={{ textDecoration: 'none', display: 'block' }}>
                    +1 647-792-0124
                  </Typography>
                  <Typography variant="body2" color="text.secondary" component="a" href="tel:+1-6477224348" sx={{ textDecoration: 'none', display: 'block', mt: 0.5 }}>
                    +1 647-722-4348 (WhatsApp)
                  </Typography>
                </Box>
              </Grid>

              {/* Email */}
              <Grid item xs={12} md={4}>
                <Box sx={{ textAlign: 'center', p: 4, borderRadius: 2, bgcolor: 'rgba(145,158,171,0.08)', height: '100%', transition: 'all 0.3s ease', '&:hover': { transform: 'translateY(-5px)', boxShadow: 3 } }}>
                  <Box sx={{ 
                    width: 80, height: 80, margin: '0 auto', mb: 3, 
                    display: 'flex', alignItems: 'center', justifyContent: 'center', 
                    borderRadius: '50%', background: `linear-gradient(135deg, var(--app-color) 0%, ${theme.palette.primary.dark} 100%)`, color: '#fff',
                    boxShadow: `0 8px 16px 0 rgba(25, 118, 210, 0.24)`
                  }}>
                    <EmailIcon sx={{ fontSize: 40 }} />
                  </Box>
                  <Typography variant="h5" fontWeight={600} gutterBottom color="text.primary">
                    Email Us
                  </Typography>
                  <Typography variant="body1" color="text.secondary" component="a" href="mailto:info@chargemiles.ca" sx={{ textDecoration: 'none', display: 'block', mb: 1 }}>
                    info@chargemiles.ca
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Support response within 24hrs
                  </Typography>
                </Box>
              </Grid>

              {/* Location */}
              <Grid item xs={12} md={4}>
                <Box sx={{ textAlign: 'center', p: 4, borderRadius: 2, bgcolor: 'rgba(145,158,171,0.08)', height: '100%', transition: 'all 0.3s ease', '&:hover': { transform: 'translateY(-5px)', boxShadow: 3 } }}>
                  <Box sx={{ 
                    width: 80, height: 80, margin: '0 auto', mb: 3, 
                    display: 'flex', alignItems: 'center', justifyContent: 'center', 
                    borderRadius: '50%', background: `linear-gradient(135deg, var(--app-color) 0%, ${theme.palette.primary.dark} 100%)`, color: '#fff',
                    boxShadow: `0 8px 16px 0 rgba(25, 118, 210, 0.24)`
                  }}>
                    <LocationOnIcon sx={{ fontSize: 40 }} />
                  </Box>
                  <Typography variant="h5" fontWeight={600} gutterBottom color="text.primary">
                    Our Location
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    10 Biggood Drive, Ajax
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                    L1Z0E2, Ontario, Canada
                  </Typography>
                </Box>
              </Grid>

            </Grid>
          </Box>
        </Card>
      </Container>
    </Page>
  );
}
